import React, { useState, useEffect, useRef } from "react";
import { GetServiceCaller } from "../services/serviceCaller";
import { API_URL } from "../constants";

const EmployeeSearchDropdown = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredEmployee, setFilteredEmployee] = useState([]);
  const [emplistOptions, setEmplistOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const searchTimeoutRef = useRef(null);

  useEffect(() => {
    fetchOrgAllEmployee();
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  const fetchOrgAllEmployee = async () => {
    setIsLoading(true);
    try {
      const response = await GetServiceCaller(`${API_URL}nest/dashboard/filter-employee`);
      if (response?.status === 200) {
        const empList = response?.data?.data || [];
        const formattedOptions = empList.map((emp) => ({
          value: emp.ID,
          label: emp.Title,
          number: emp.MobileNo,
          email: emp.Email,
          type: emp.Type,
        }));
        setEmplistOptions(formattedOptions);
      } else {
        setEmplistOptions([]);
      }
    } catch (err) {
      console.error("Fetching Error Search Emp API ", err);
      setEmplistOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setShowResults(false);
    setIsSearching(true);

    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);

    if (!value.trim()) {
      setFilteredEmployee([]);
      setIsSearching(false);
      return;
    }

    const delay = 900;
    searchTimeoutRef.current = setTimeout(() => {
      const lowerValue = value.toLowerCase().trim();

      let filtered = emplistOptions.filter((item) => {
        const name = item.label?.toLowerCase() || "";
        const email = item.email?.toLowerCase() || "";
        const number = item.number?.toString().toLowerCase() || "";
        return (
          name.includes(lowerValue) ||
          email.includes(lowerValue) ||
          number.includes(lowerValue)
        );
      });

      filtered.sort((a, b) => a.label.localeCompare(b.label));
      filtered = filtered.slice(0, 10);

      setFilteredEmployee(filtered);
      setIsSearching(false);
      setShowResults(true);
    }, delay);
  };

  const handleSelectEmp = (emp) => {
    const basePath = window.location.origin;
    const url =
      emp.type === "EMP" || emp.type === "EX-EMP"
        ? `${basePath}/employee-profile/${emp.value}`
        : `${basePath}/Candidates/viewHistory/${emp.value}`;
    window.open(url, "_blank");
  };

  return (
    <div className="dropdown show" style={{ position: "relative" }}>
      <ul
        className="dropdown-menu employee-profile p-2 m-0 show mt-2"
        style={{
          left: "30%",
          transform: "translateX(-50%)",
          top: "9px",
          minWidth: "220px",
          maxWidth: "320px",
          position: "absolute",
          zIndex: 1050,
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          borderRadius: "8px",
        }}
      >
        {/* Search Box */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #D9D9D9",
            borderRadius: "8px",
            padding: "0 12px",
            width: "200px",
            marginBottom: "10px",
          }}
        >
          <i
            className="bi bi-search"
            style={{ color: "#6c757d", marginRight: "8px", fontSize: "16px" }}
          />
          <input
            type="text"
            placeholder="Search employees..."
            value={searchTerm}
            onChange={handleSearch}
            style={{
              padding: "8px 0",
              fontSize: "12px",
              border: "none",
              backgroundColor: "transparent",
              outline: "none",
              flex: 1,
            }}
          />
        </div>

        {/* Results */}
        {isSearching ? (
          <li className="text-center m-0 p-2">
            <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            Searching...
          </li>
        ) : showResults && filteredEmployee.length === 0 ? (
          <li className="text-center m-0 p-2">No employees found</li>
        ) : (
          showResults &&
          filteredEmployee.length > 0 && (
            <ul
              className="list-group"
              style={{
                maxHeight: "180px",
                overflowY: "auto",
                paddingRight: "4px",
              }}
            >
              {filteredEmployee.map((employee) => (
                <li
                  key={employee.value}
                  onClick={() => handleSelectEmp(employee)}
                  className="list-group-item list-group-item-action"
                  style={{ cursor: "pointer", fontSize: "12px" }}
                >
                  <div className="d-flex flex-column">
                    <strong>
                      [{employee.type}] {employee.label}
                    </strong>
                    <small>{employee.email}</small>
                    <small>{employee.number}</small>
                  </div>
                </li>
              ))}
            </ul>
          )
        )}
      </ul>
    </div>
  );
};

export default EmployeeSearchDropdown;
